import { render, staticRenderFns } from "./BillView.vue?vue&type=template&id=1f9d37d2&scoped=true&"
import script from "./BillView.vue?vue&type=script&lang=ts&"
export * from "./BillView.vue?vue&type=script&lang=ts&"
import style0 from "./BillView.vue?vue&type=style&index=0&id=1f9d37d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d37d2",
  null
  
)

export default component.exports